import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginSuccess } from "../../store/authReducer";
import { Container, Col, Button, Table, Nav, Modal } from "react-bootstrap";
import {
  logoutSuccess,
  setUserData,
  clearUserData,
} from "../../store/authReducer";
import "./Dashboard.scss";
import { saveAs } from "file-saver";
import TestScenario from "./TestScenario";
import Sidebar from "./Sidebar";
import TestCase from "./TestCase";
import RecentTests from "./RecentTests";
const testOptions = [
  { value: "Functional Test", label: "Functional Test" },
  { value: "Functional Positive", label: "Functional Positive" },
  { value: "Functional Negative", label: "Functional Negative" },
  { value: "Performance Test", label: "Performance Test" },
  { value: "Security Test", label: "Security Test" },
];

const typeOptions = [
  { value: "API", label: "API" },
  { value: "UI", label: "UI" },
  { value: "DB", label: "DB" },
];

const methodOptions = [
  { value: "AI Assistant", label: "AI Assistant" },
  { value: "Internal Documents", label: "Internal Documents" },
];
const API_URL = `${process.env.REACT_APP_API_URL}test_case_generation/create_test_case_document`;
const Upload_API_URL = `${process.env.REACT_APP_API_URL}test_case_generation/upload_document`;
const Dashboard = () => {
  const token = useSelector((state) => state.auth.token);
  const IdToken = localStorage.getItem("msalIdToken");
  // const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.userData);
  const { instance } = useMsal();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("testScenario");
  const [showSearch, setShowSearch] = useState(false);
  const [inputData, setInputData] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [userStoryID, setUserStoryID] = useState("");
  const [testingType, setTestingType] = useState(null);
  const [coverage, setCoverage] = useState([]);
  const [method, setMethod] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [acceptanceCriteria, setAcceptanceCriteria] = useState("");
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const [storeSingelRes, setStoreSingelRes] = useState(null);
  const [validationErrorMsg, setValidationErrorMsg] = useState("");
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [cancelSubmit, setCancelSubmit] = useState(false); // to skip the rest of submission
  const [validationWarningTriggered, setValidationWarningTriggered] =
    useState(false);
  useEffect(() => {
    if (token) {
      let isMounted = true;
      fetch("https://graph.microsoft.com/v1.0/me", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (isMounted) {
            dispatch(setUserData(data));
          }
        })
        .catch((error) => console.error("Error fetching user data:", error));

      return () => {
        isMounted = false;
      };
    }
  }, [token, dispatch]);

  // Handle form submission with validation
  const handleSubmit = async (e, bypassWarning = false) => {
    e.preventDefault();
    setCancelSubmit(false);
    setValidationWarningTriggered(false);

    // Local validation
    let newErrors = {};
    if (!userStoryID) newErrors.userStoryID = "User Story ID is required.";
    if (!testingType) newErrors.testingType = "Testing Type is required.";
    if (coverage.length === 0)
      newErrors.coverage = "Coverage selection is required.";
    if (!method) newErrors.method = "Method selection is required.";
    if (!title) newErrors.title = "Title is required.";
    if (!description) newErrors.description = "Description is required.";
    if (!acceptanceCriteria)
      newErrors.acceptanceCriteria = "Acceptance Criteria is required.";
    if (method?.value === "Internal Documents" && !file)
      newErrors.file = "File upload is required for Internal Documents.";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    // Validation API call (only if not bypassed)
    if (!bypassWarning) {
      try {
        const validationResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}test_case_generation/reason_test_case_document`,
          {
            user_story_title: title,
            user_story_description: description,
            acceptance_criteria: acceptanceCriteria,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const validationData = validationResponse?.data;

        if (
          typeof validationData === "string" &&
          validationData.trim().toLowerCase() !== "continue"
        ) {
          // Show modal warning
          setValidationErrorMsg(validationData);
          setValidationWarningTriggered(true);
          setShowValidationModal(true);
          return;
        }
      } catch (validationError) {
        console.error("Validation API failed:", validationError);
        return;
      }
    }

    // Continue submission
    setIsUploading(true);
    setProgress(0);
    const formattedCoverage = coverage?.value;
    const payload = {
      scenario: formattedCoverage,
      testing_type: testingType?.value,
      user_story_description: description,
      method: method?.value,
      user_id: userData?.mail,
      user_story_id: userStoryID,
      user_story_title: title,
      acceptance_criteria: acceptanceCriteria,
    };

    try {
      const startTime = Date.now();
      let uploadEndTime = startTime;

      if (method?.value === "Internal Documents") {
        const formData = new FormData();
        formData.append("file", file);

        await axios.post(
          `${Upload_API_URL}?user_id=${userData?.mail}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${IdToken}`,
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (event) => {
              if (event.total) {
                const elapsedTime = Date.now() - startTime;
                const progressValue = Math.round(
                  Math.min(50, (elapsedTime / (elapsedTime + 1000)) * 50)
                );
                setProgress(progressValue);
              }
            },
          }
        );

        uploadEndTime = Date.now();
      }

      const response = await axios.post(API_URL, payload, {
        headers: {
          Authorization: `Bearer ${IdToken}`,
          "Content-Type": "application/json",
        },
        onUploadProgress: (event) => {
          if (event.total) {
            const elapsedTime = Date.now() - uploadEndTime;
            const progressValue = Math.round(
              50 + Math.min(50, (elapsedTime / (elapsedTime + 1000)) * 50)
            );
            setProgress(progressValue);
          }
        },
      });

      setInputData(response.data);
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setIsUploading(false);
      setProgress(100);
    }

    setStoreSingelRes(null);
  };

  const logout = () => {
    instance.logoutRedirect();
    dispatch(logoutSuccess());
    dispatch(clearUserData());
    navigate("/login");
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  // Extract keys for table headers
  const tableHeaders =
    inputData?.generated_test_cases?.length > 0
      ? Object.keys(inputData.generated_test_cases[0])
      : [];
  // Copy table content to clipboard
  const handleCopy = () => {
    const tableData = [
      tableHeaders.join("\t"), // Join headers with tab
      ...inputData?.generated_test_cases.map((tc) =>
        tableHeaders.map((header) => tc[header]).join("\t")
      ),
    ].join("\n");

    navigator.clipboard
      .writeText(tableData)
      .then(() => alert("Table content copied!"))
      .catch((err) => console.error("Failed to copy:", err));
  };

  const renewToken = async () => {
    await instance.initialize();
    const account = instance.getActiveAccount();
    if (!account) return;

    try {
      const response = await instance.acquireTokenSilent({
        scopes: ["User.Read"],
        account: account,
      });
      localStorage.setItem("msalToken", response.accessToken);
      localStorage.setItem("msalIdToken", response.idToken);
      dispatch(loginSuccess(account, response.accessToken));
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        try {
          // Try popup login first (less disruptive)
          const popupResponse = await instance.acquireTokenPopup({
            scopes: ["User.Read"],
          });
          localStorage.setItem("msalToken", popupResponse.accessToken);
          localStorage.setItem("msalIdToken", popupResponse.idToken);
          dispatch(loginSuccess(account, popupResponse.accessToken));
        } catch (popupError) {
          console.error(
            "Popup token acquisition failed, redirecting...",
            popupError
          );
          instance.acquireTokenRedirect({ scopes: ["User.Read"] });
        }
      } else {
        console.error("Silent token acquisition failed", error);
      }
    }
  };

  const checkAndRefreshToken = async () => {
    const storedToken = localStorage.getItem("msalToken");
    if (!storedToken) {
      renewToken(); // If no token exists, force renewal
      return;
    }

    try {
      const tokenPayload = JSON.parse(atob(storedToken.split(".")[1]));
      const tokenExpiration = tokenPayload.exp * 1000;
      const currentTime = Date.now();

      if (tokenExpiration - currentTime < 1 * 30 * 1000) {
        console.log("Token is about to expire, refreshing...");
        await renewToken();
      }
    } catch (error) {
      renewToken();
    }
  };

  // Run initially and check periodically
  useEffect(() => {
    checkAndRefreshToken();
    const interval = setInterval(checkAndRefreshToken, 50 * 60 * 1000);
    return () => clearInterval(interval);
  }, [instance, dispatch]);
  const handleExportCSV = () => {
    if (!inputData?.generated_test_cases?.length) {
      console.error("No test cases available");
      return;
    }
    // Extract headers dynamically
    const tableHeaders = Object.keys(inputData.generated_test_cases[0]);
    // Generate CSV rows, ensuring correct alignment
    const csvRows = inputData.generated_test_cases.map((tc) =>
      tableHeaders
        .map((header) => {
          let value = tc[header] ?? ""; // Handle missing values
          if (typeof value === "object") {
            value = JSON.stringify(value); // Convert objects to JSON string
          }
          return `"${value.replace(/"/g, '""')}"`; // Escape quotes
        })
        .join(",")
    );
    const csvContent = [tableHeaders.join(","), ...csvRows].join("\n");
    // Create a CSV file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    // Trigger file download
    saveAs(blob, `TestCases_${userStoryID}.csv`);
  };
  // handle create new test case
  const handleCreateNewTestCase = () => {
    setUserStoryID("");
    setTestingType(null);
    setCoverage([]);
    setMethod(null);
    setTitle("");
    setDescription("");
    setAcceptanceCriteria("");
    setFile(null);
    setInputData("");
    setErrors({});
  };
  const API_URLS = {
    TESTS: `${process.env.REACT_APP_API_URL}test_case_generation/get_all_test_cases`,
    SCENARIOS: `${process.env.REACT_APP_API_URL}test_case_generation/get_all_test_scenarios`,
  };

  const fetchData = async (url, userId, token, setData) => {
    try {
      const response = await axios.get(`${url}?user_id=${userId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const [testCases, setTestCases] = useState([]);
  const [testScenarios, setTestScenarios] = useState([]);
  const [selectedTestCase, setSelectedTestCase] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const userId = userData?.mail;

  const GET_TESTCASE_BY_ID = `${process.env.REACT_APP_API_URL}test_case_generation/view_test_case`;
  const GET_TESTSCENARIO_BY_ID = `${process.env.REACT_APP_API_URL}test_case_generation/view_test_scenario`;
  // function to get the particular  test scenario /test case based on the  doc_id
  const getTestCaseById = async (data, url) => {
    try {
      const response = await axios.get(`${url}?doc_id=${data.doc_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${IdToken}`,
        },
      });
      const res = response?.data;
      setSelectedTestCase(res);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (userId && IdToken) {
      fetchData(API_URLS.TESTS, userId, IdToken, setTestCases);
      fetchData(API_URLS.SCENARIOS, userId, IdToken, setTestScenarios);
    }
  }, [userId, IdToken]);
  // function to handle the tab change
  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    if (tabKey === "testScenario") {
      fetchData(API_URLS.SCENARIOS, userId, IdToken, setTestScenarios);
    } else if (tabKey === "testCase") {
      fetchData(API_URLS.TESTS, userId, IdToken, setTestCases);
    }
    setSelectedTestCase([]);
    setStoreSingelRes(null);

    handleCreateNewTestCase();
  };
  const isRowSelected = !!selectedTestCase?.doc_id;
  return (
    <>
      {/* <div className="dashboard-scrollable"> */}
      <div className="d-flex">
        <Sidebar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          showSearch={showSearch}
          setShowSearch={setShowSearch}
          testCases={testCases}
          testScenarios={testScenarios}
          setSelectedTestCase={setSelectedTestCase}
          getTestCaseById={getTestCaseById}
          GET_TESTSCENARIO_BY_ID={GET_TESTSCENARIO_BY_ID}
          GET_TESTCASE_BY_ID={GET_TESTCASE_BY_ID}
          handleTabChange={handleTabChange}
          setStoreSingelRes={setStoreSingelRes}
          storeSingelRes={storeSingelRes}
        />
        <div className="flex-grow-1">
          <Header userData={userData} logout={logout} />
          <Container className="mt-3">
            <Nav
              variant="tabs"
              activeKey={activeTab}
              onSelect={(selectedKey) => {
                setActiveTab(selectedKey);
                handleTabChange(selectedKey);
              }}
            >
              {/* <Nav.Item>
              <Nav.Link eventKey="recentTests">Recent Tests</Nav.Link>
            </Nav.Item> */}
              <Nav.Item>
                <Nav.Link eventKey="testScenario">Test Scenario</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="testCase">Test Case</Nav.Link>
              </Nav.Item>
            </Nav>
            {activeTab === "testCase" && (
              <>
                <TestCase
                  activeTab={activeTab}
                  handleSubmit={handleSubmit}
                  userStoryID={userStoryID}
                  setUserStoryID={setUserStoryID}
                  testingType={testingType}
                  setTestingType={setTestingType}
                  coverage={coverage}
                  setCoverage={setCoverage}
                  method={method}
                  setMethod={setMethod}
                  title={title}
                  setTitle={setTitle}
                  description={description}
                  setDescription={setDescription}
                  acceptanceCriteria={acceptanceCriteria}
                  setAcceptanceCriteria={setAcceptanceCriteria}
                  file={file}
                  setFile={setFile}
                  errors={errors}
                  setErrors={setErrors}
                  isUploading={isUploading}
                  progress={progress}
                  inputData={inputData}
                  handleCreateNewTestCase={handleCreateNewTestCase}
                  methodOptions={methodOptions}
                  handleExportCSV={handleExportCSV}
                  handleCopy={handleCopy}
                  tableHeaders={tableHeaders}
                  setInputData={setInputData}
                  IdToken={IdToken}
                  userData={userData}
                  API_URL={API_URL}
                  Upload_API_URL={Upload_API_URL}
                  typeOptions={typeOptions}
                  testOptions={testOptions}
                  selectedTestCase={selectedTestCase}
                  isRowSelected={isRowSelected}
                  setSelectedTestCase={setSelectedTestCase}
                  testCases={testCases}
                  setStoreSingelRes={setStoreSingelRes}
                  storeSingelRes={storeSingelRes}
                />
              </>
            )}
            {activeTab === "testScenario" && (
              <TestScenario
                selectedTestCase={selectedTestCase}
                isRowSelected={isRowSelected}
                setSelectedTestCase={setSelectedTestCase}
                testScenarios={testScenarios}
                setStoreSingelRes={setStoreSingelRes}
                storeSingelRes={storeSingelRes}
                handleCreateNewTestCase={handleCreateNewTestCase}
              />
            )}

            {/* {activeTab === "recentTests" && <RecentTests />} */}
          </Container>
        </div>
        <Modal
  show={showValidationModal}
  onHide={() => setShowValidationModal(false)}
  centered
  backdrop="static"
  keyboard={false}
>
  {/* Modal Header */}
  <Modal.Header
    closeButton
    className="border-0"
    style={{ backgroundColor: "#FFF4CC" }}
  >
    <Modal.Title
      className="fw-bold"
      style={{ color: "#D97706" }}
    >
      ⚠️ Validation Warning
    </Modal.Title>
  </Modal.Header>

  {/* Modal Body */}
  <Modal.Body className="text-center px-4">
    <p
      className="fw-semibold fs-5 m-0"
      style={{ color: "#DC2626" }}
    >
      {validationErrorMsg}
    </p>
  </Modal.Body>

  {/* Modal Footer */}
  <Modal.Footer className="justify-content-center border-0 pb-4">
    {/* Revise Button */}
    <Button
      style={{
        backgroundColor: "#6B7280", 
        color: "#FFFFFF",         
        border: "none",
      }}
      onMouseEnter={(e) => (e.target.style.backgroundColor = "#4B5563")} // Revise hover
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#6B7280")}
      onClick={() => {
        setShowValidationModal(false);
        setCancelSubmit(true);
      }}
      className="px-4"
    >
      Revise
    </Button>

    {/* Proceed Anyway Button */}
    <Button
      style={{
        backgroundColor: "#2563EB",
        color: "#FFFFFF",         
        border: "none",
      }}
      onMouseEnter={(e) => (e.target.style.backgroundColor = "#1D4ED8")} // Proceed hover
      onMouseLeave={(e) => (e.target.style.backgroundColor = "#2563EB")}
      onClick={(e) => {
        setShowValidationModal(false);
        handleSubmit(e, true);
      }}
      className="px-4"
    >
      Proceed Anyway
    </Button>
  </Modal.Footer>
</Modal>

      </div>
      {/* </div> */}
    </>
  );
};

export default Dashboard;
